var React = require('react');

function FacebookIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15.391 15.563H16.799V14.203C16.735 13.4701 16.891 12.7348 17.247 12.091C17.4961 11.7511 17.8267 11.4794 18.2083 11.3008C18.59 11.1222 19.0105 11.0425 19.431 11.069C20.2815 11.0309 21.133 11.1165 21.959 11.323L21.607 13.403C21.2363 13.3023 20.855 13.2459 20.471 13.235C19.927 13.235 19.431 13.427 19.431 13.979V15.579H21.679L21.519 17.619H19.431V24.669H16.799V17.603H15.391V15.563Z","fill":"#FBD872","key":0}),React.createElement("path",{"d":"M18 35.5C27.665 35.5 35.5 27.665 35.5 18C35.5 8.33502 27.665 0.5 18 0.5C8.33502 0.5 0.5 8.33502 0.5 18C0.5 27.665 8.33502 35.5 18 35.5Z","stroke":"#FED880","strokeOpacity":"0.3","key":1})]);
}

FacebookIcon.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = FacebookIcon;

FacebookIcon.default = FacebookIcon;
